module.exports = __webpack_public_path__ + "media/images/icons/facebook-e4ce671cfd38a85c884afc84fa51830a.svg";